export class ClipboardFormats {
    public static TEXT_FORMAT: string = "air:text";
}